export const validDateFormat = "MM/DD/YYYY";
export const monthYearFormat = "MMM YYYY";

export default { validDateFormat, monthYearFormat };
